var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceSlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 94,
    viewBox: "0 0 317 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0H305C311.627 0 317 5.37258 317 12V34C309.636 34.0002 303.667 39.9696 303.667 47.3333C303.667 54.697 309.636 60.6665 317 60.6667V82C317 88.6274 311.627 94 305 94H12C5.37259 94 0 88.6274 0 82V60.6626C0.110781 60.6653 0.221897 60.6667 0.333333 60.6667C7.69713 60.6667 13.6667 54.6971 13.6667 47.3333C13.6667 39.9695 7.69713 34 0.333333 34C0.221897 34 0.110781 34.0014 0 34.0041V12Z",
    fill: "#4E81F4",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceSlip);
export default __webpack_public_path__ + "static/media/priceSlip.c5e171cbea43b2ce6956c407fd5099de.svg";
export { ForwardRef as ReactComponent };